export default {
    meta: {
        title: '客流分析',
        isShowNav: true,
        activeMenu: '/booth',
        crumbs: {
            path: ['/booth'],
            name: ['展位管理'],
        },
    },
};
